<form
  [formGroup]="form"
  [patchForm]="serieProposal"
  [canEdit]="[accessRights.SerieProposal_write]"
>
  <div class="row">
    <div class="mb-4 col">
      <label class="form-label">
        {{ 'productModule.resource' | translate }}
      </label>

      <div>
        <strong>
          {{
            (serieProposal.productId
              | getTranslation : 'product' : 'description'
              | async) ||
              (productEntities$ | async)[serieProposal.productId]?.description
          }}
        </strong>
      </div>

      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="form.controls.productId.dirty && form.controls.productId.invalid"
      >
        {{ 'productModule.resource' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4 col-4">
      <label class="form-label">
        {{ 'general.location' | translate }}
      </label>

      <div>
        <strong>
          {{
            (locationEntities$ | async)[
              (productEntities$ | async)[serieProposal.productId]?.locationId
            ]?.description
          }}
        </strong>
      </div>

      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="form.controls.productId.dirty && form.controls.productId.invalid"
      >
        {{ 'productModule.resource' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4 col-lg-6">
      <label class="form-label">
        {{ 'organizationModule.organization' | translate }}
      </label>

      <div>
        <strong>
          {{
            (organizationEntities$ | async)[serieProposal.organizationId]
              ?.description
          }}
          <span
            *ngIf="
              (organizationEntities$ | async)[serieProposal.organizationId]
                ?.abbreviation
            "
          >
            ({{
              (organizationEntities$ | async)[serieProposal.organizationId]
                ?.abbreviation
            }})
          </span>
        </strong>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="mb-4 col">
      <label class="form-label">
        {{ 'general.startDate' | translate }}
      </label>

      <p class="mb-0">
        {{
          form.controls.startDate?.value
            | date : 'd MMMM yyyy' : null : (selectedLanguage$ | async)
        }}
      </p>
    </div>
    <div class="mb-4 col-lg-4">
      <label class="form-label">
        {{ 'general.endDate' | translate }}
      </label>

      <p class="mb-0">
        {{
          form.controls.endDate?.value
            | date : 'd MMMM yyyy' : null : (selectedLanguage$ | async)
        }}
      </p>
    </div>

    <div class="mb-4 col-lg-6">
      <label class="form-label">
        {{ 'serieProposalModule.contactPerson' | translate }}
      </label>

      <div>
        {{
          (memberEntities$ | async)[serieProposal.customerPersonId]?.firstName
        }}
        {{
          (memberEntities$ | async)[serieProposal.customerPersonId]?.lastName
        }}
        <br />
        {{ (memberEntities$ | async)[serieProposal.customerPersonId]?.email }}
        <br />
        {{ (memberEntities$ | async)[serieProposal.customerPersonId]?.mobile }}
      </div>

      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          form.controls.customerPersonId.dirty &&
          form.controls.customerPersonId.invalid
        "
      >
        {{ 'serieProposalModule.contactPerson' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>
  </div>

  <div class="row">
    <div class="mb-4 col-lg-6">
      <div>
        <label class="form-label">
          {{ 'serieProposalModule.proposalType' | translate }}
        </label>
      </div>
      <div>
        <div class="nav nav-segment">
          <!-- REPEATABLE_BOOKING radio button -->
          <input
            type="radio"
            class="btn-check"
            name="proposalType"
            [value]="serieProposalType.REPEATABLE_BOOKING"
            id="repeatableBookingBtn"
            autocomplete="off"
            [checked]="
              serieProposal.type === serieProposalType.REPEATABLE_BOOKING
            "
            (click)="$event.preventDefault()"
          />
          <label class="nav-link" for="repeatableBookingBtn">
            {{ 'serieProposalModule.repeatableBooking' | translate }}
          </label>

          <!-- CUSTOM_DATE radio button -->
          <input
            type="radio"
            class="btn-check"
            name="proposalType"
            [value]="serieProposalType.CUSTOM_DATE"
            id="customDatesBtn"
            autocomplete="off"
            [checked]="serieProposal.type === serieProposalType.CUSTOM_DATE"
            (click)="$event.preventDefault()"
          />
          <label class="nav-link" for="customDatesBtn">
            {{ 'serieProposalModule.customDates' | translate }}
          </label>
        </div>
      </div>
    </div>

    <div class="mb-4 col-lg-6">
      <label class="form-label">
        {{ 'serieProposalModule.groupInformation' | translate }}
      </label>

      <p> {{ form.controls?.groupInformation?.value ?? '-' }} </p>
    </div>
  </div>
  <ng-container *ngIf="serieProposal.type === serieProposalType.CUSTOM_DATE">
    <div
      *ngFor="let serieItemId of serieProposal.serieProposalItems"
      class="row"
    >
      <div
        *ngIf="
          (serieProposalItemEntities$ | async)[serieItemId]?.status !=
          serieProposalItemStatus.DECLINED
        "
        class="col-lg-6 mb-2 d-flex gap-3"
      >
        <div>
          <div>
            {{
              (serieProposalItemEntities$ | async)[serieItemId].startDate
                | date : 'dd-MM-YYYY'
            }}
            {{
              (serieProposalItemEntities$ | async)[serieItemId].startDate
                | date : 'HH:mm'
            }}
            -
            {{
              (serieProposalItemEntities$ | async)[serieItemId].endDate
                | date : 'dd-MM-YYYY'
            }}
            {{
              (serieProposalItemEntities$ | async)[serieItemId].endDate
                | date : 'HH:mm'
                | roundMinutes
            }}
          </div>
          <div>
            <small>
              (
              {{
                ((serieProposalItemEntities$ | async)[serieItemId]?.productId ??
                  serieProposal.productId
                  | getTranslation : 'product' : 'description'
                  | async) ||
                  (productEntities$ | async)[
                    (serieProposalItemEntities$ | async)[serieItemId]
                      ?.productId ?? serieProposal.productId
                  ]?.description
              }}
              -
              {{
                (locationEntities$ | async)[
                  (productEntities$ | async)[
                    (serieProposalItemEntities$ | async)[serieItemId]?.productId
                  ]?.locationId
                ]?.description
              }}
              )
            </small>
          </div>
        </div>

        <div *ngIf="serieProposal.status != serieProposalStatus.ACCEPTED">
          <button
            [canSee]="[accessRights.SerieProposal_write]"
            class="btn btn-sm btn-ghost-primary"
            (click)="onClickDecline(serieItemId)"
          >
            <i
              role="img"
              class="fa fa-trash"
              role="img"
              attr.aria-label="{{ 'general.delete' | translate }}"
            ></i>
          </button>

          <button
            [canSee]="[accessRights.SerieProposal_write]"
            class="btn btn-sm btn-ghost-primary"
            (click)="onClickEditItem(serieItemId)"
          >
            <i
              role="img"
              class="fa fa-pencil-alt"
              role="img"
              attr.aria-label="{{ 'general.edit' | translate }}"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="serieProposal.type === serieProposalType.REPEATABLE_BOOKING"
  >
    <!-- Days of the week -->
    <div class="mb-4">
      <label class="form-label">
        {{ 'serieProposalModule.dayOfTheWeek' | translate }}
      </label>

      <div class="mb-2">
        <ng-container *ngFor="let day of daysOfWeek">
          <button
            class="btn btn-white rounded-circle avatar btn-sm pe-none"
            tabindex="-1"
            [ngClass]="{
              'btn-white': !isDaySelected(day),
              'btn-primary': isDaySelected(day)
            }"
            type="button"
            attr.aria-label="{{ 'general.day' + day | translate }}"
          >
            {{ 'general.dayAbbreviation' + day | translate }}
          </button>
        </ng-container>
      </div>
    </div>

    <div *ngFor="let day of selectedDays" class="row">
      <div
        class="col-lg-6 mb-2 d-flex align-items-center justify-content-between"
      >
        <div>
          <label class="form-label">
            {{ 'general.day' + day | translate }}
            {{ 'serieProposalModule.startAndEndTime' | translate | lowercase }}
          </label>
          <p>
            {{ getTimesForDay(day).startTime }} -
            {{ getTimesForDay(day).endTime }}
          </p>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="row">
    <div class="mb-4 col-lg-6">
      <label class="form-label" for="internalMemoText">
        {{ 'serieProposalModule.internalMemo' | translate }}
      </label>
      <div class="input-group">
        <input
          class="form-control"
          type="text"
          formControlName="internalMemo"
          name="proposalType"
          id="internalMemoText"
          autocomplete="off"
        />
        <button
          [canSee]="[accessRights.SerieProposal_write]"
          type="button"
          class="btn btn-sm btn-soft-success"
          [disabled]="
            form.controls?.internalMemo?.dirty &&
            form.controls.internalMemo?.invalid
          "
          (click)="$event.preventDefault(); updateinternalMemo()"
          aria-controls="internalMemoText"
        >
          <i
            role="img"
            class="fa fa-check"
            attr.aria-label="{{ 'general.confirm' | translate }}"
          ></i>
        </button>
      </div>
    </div>
    <div class="mb-4 col-lg-6">
      <div class="form-label">
        {{ 'serieProposalModule.externalMemo' | translate }}
      </div>
      <p class="mb-0">
        {{ form.controls?.externalMemo?.value ?? '-' }}
      </p>
    </div>
  </div>

  <div
    *ngIf="serieProposal.status != serieProposalStatus.DECLINED"
    class="d-flex justify-content-end pt-3"
  >
    <div
      class="spinner-border"
      role="status"
      attr.aria-label="{{ 'general.loading' | translate }}"
      *ngIf="isLoading$ | async"
    >
    </div>

    <button
      [canSee]="[accessRights.SerieProposal_delete]"
      *ngIf="serieProposal.status != serieProposalStatus.ACCEPTED"
      class="btn btn-soft-danger"
      type="button"
      (click)="onClickDecline()"
    >
      {{
        serieProposal.details.repeatableBookings.length > 1
          ? ('serieProposalModule.declineAll' | translate)
          : ('serieProposalModule.decline' | translate)
      }}
    </button>

    <button
      [canSee]="[accessRights.SerieProposal_write]"
      *ngIf="showEditButton()"
      class="btn btn-soft-primary"
      type="button"
      (click)="onClickEdit()"
    >
      {{ 'general.edit' | translate }}
    </button>

    <button
      [canSee]="[accessRights.SerieProposal_write, accessRights.Bookings_write]"
      *ngIf="serieProposal.status != serieProposalStatus.ACCEPTED"
      class="btn btn-primary"
      (click)="onClickAccept()"
    >
      {{ 'general.accept' | translate }}
    </button>
  </div>
</form>
